import type { Locale } from "@/lib/i18n";
import { pl, type WDropDownMenuTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wDropDownMenuTranslations: Record<Locale, WDropDownMenuTranslations> = {
  pl,
  en,
  de,
};

export type { WDropDownMenuTranslations };
